<template>
  <v-select
    id="group-solution-select"
    v-model="filter.municipioGrupoSolucao"
    item-text="nome"
    item-value="municipioGrupoSolucaoId"
    :items="onlyEnable ? onlyEnableGroupSolutionList : groupSolutionList"
    label="Grupo de Solução"
    placeholder="Grupo de Solução"
    :clearable="true"
    :return-object="true"
    @change="change"
  >
    <template slot="no-data">
      Nenhum Grupo de Solução retornado
    </template>
  </v-select>
</template>

<script>
import { cityGroupSolutionAPI } from "@/modules/city/API/CityGroupSolutionAPI";
import { mapGetters } from "vuex";

export default {
  name: "AppGroupSolutionByCityCombobox",
  props: ["filter", "reload", "onlyEnable"],
  mounted() {
    this.loadGroupSolution();
  },
  computed: {
    ...mapGetters(["reloadTRGroup"])
  },
  methods: {
    loadGroupSolution() {
      cityGroupSolutionAPI
        .listByCity(this.$route.params.id)
        .then(resp => {
          this.groupSolutionList = resp.data;
          this.onlyEnableGroupSolutionList = resp.data.filter(
            item => item.desabilitado === false
          );
        })
        .catch();
    },
    change(value) {
      if (value) this.filter.municipioGrupoSolucao = value;
      else this.filter.municipioGrupoSolucao = {};

      this.$emit("changeGroupSolution");
    }
  },
  data() {
    return {
      groupSolutionList: [],
      onlyEnableGroupSolutionList: []
    };
  },
  watch: {
    reloadTRGroup: {
      handler(val, oldVal) {
        this.loadGroupSolution();
      },
      deep: true
    }
  }
};
</script>
